export const placesTableColumns = [
  {
    prop: 'short_name',
    title: 'common.fields.short_name',
    width: '38%',
    sortingEnabled: true,
  },
  {
    prop: 'full_address',
    title: 'common.fields.full_address',
    width: '50%',
    sortingEnabled: true,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '12%',
    sortingEnabled: false,
  },
];
